import { useCallback } from "react";
import { useCurrentAccountId } from "@zapier/identity";
import emitUserInteractionEvent, {
  UserInteractionName,
} from "./emitUserInteractionEvent";

export type ShareUpsellOption = "share_template";

interface EmitShareUpsellEvent {
  optionSelected: ShareUpsellOption;
  assetId?: string;
  interactionRawText?: string;
}

/**
 * Fires when someone on a plan without teams clicks the upgrade CTA in a
 * sharing surface.
 */
export function useEmitShareUpsellEvent() {
  const accountId = useCurrentAccountId();

  const emit = useCallback(
    ({ optionSelected, assetId, interactionRawText }: EmitShareUpsellEvent) => {
      emitUserInteractionEvent({
        accountId,
        interactionGoal: "upsell",
        interactionName: UserInteractionName.ShareUpsell,
        interactionRawText,
        optionSelected,
        customTrackingFields: {
          asset_id: assetId,
        },
      });
    },
    [accountId],
  );

  return {
    emit,
  };
}
